import React from "react";

const PartialCloseIcon = ({
  className,
  size = 12,
  color = "#EBDDDD",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <circle cx="6" cy="6" r="5.35714" stroke={color} strokeWidth="1.28571" />
    <path
      d="M3.42859 6H8.57145"
      stroke={color}
      strokeWidth="1.28571"
      strokeLinecap="round"
    />
  </svg>
);

export default PartialCloseIcon;
